export function QOptionArray() {
  this.fArray = null;
}
